import React from 'react'
import { useHistory } from 'react-router-dom';

interface HeaderNavProps {
  title?: string;
  onBack?: () => void;
}

const HeaderNav = ({title, onBack}: HeaderNavProps) => {
  const _history = useHistory();
  const handleBack = () => {
    if(onBack) return onBack();
    _history.goBack();
  };
  return (
    <div className='header-nav'>
      <button type="button" className='back-button' onClick={handleBack} aria-label="Go back"><BackIcon /></button>
      <p className="title">{title}</p>
      <button type="button" className='back-button' disabled aria-hidden="true"><BackIcon /></button>
    </div>
  )
}

export default HeaderNav;
const BackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_219_1633)">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z" fill="#1D2129" />
    </g>
    <defs>
      <clipPath id="clip0_219_1633">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
